import { render, staticRenderFns } from "./home-card.vue?vue&type=template&id=11abf235&scoped=true"
import script from "./home-card.vue?vue&type=script&lang=js"
export * from "./home-card.vue?vue&type=script&lang=js"
import style0 from "./home-card.vue?vue&type=style&index=0&id=11abf235&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11abf235",
  null
  
)

export default component.exports